<template>
  <v-dialog max-width="1250px" :value="value" @input="$emit('input', $event)">
    <div class="speaker-modal" v-if="data">
      <v-btn class="close" icon @click="$emit('input', false)">
        <v-icon>$close</v-icon>
      </v-btn>
      <img
        class="speaker-modal__avatar"
        alt="avatar"
        :src="data.preview_urls.large"
      />
      <div class="speaker-modal__info">
        <div class="speaker-modal__name">{{ data.name }}</div>
        <div class="speaker-modal__title">{{ data.title }}</div>
        <hr class="hr-aqua" />
        <div class="speaker-modal__bio" v-html="data.biography" />
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "SpeakerModal",
  props: {
    value: Boolean,
    data: Object
  }
};
</script>

<style scoped lang="scss">
.speaker-modal {
  background: #ffffff;
  border: 4px solid $stjude-purple;
  border-radius: 10px;
  padding: 32px;
  position: relative;
  display: flex;
  align-items: flex-start;

  .close {
    right: 20px;
    top: 20px;
  }

  &__avatar {
    width: 216px;
    height: 216px;
    border-radius: 50%;
    object-fit: cover;
    object-position: top center;
  }

  &__info {
    margin-left: 32px;
    flex: 1;
  }

  &__name {
    font-weight: bold;
    font-size: 43px;
    line-height: 50px;
    color: $primary;
  }

  &__title {
    font-size: 18px;
    line-height: 24px;
    margin-top: 16px;
  }

  hr {
    margin: 20px 0;
  }

  &__bio {
    font-size: 18px;
    line-height: 24px;
    white-space: break-spaces;
  }
}

@media screen and (max-width: 960px) {
  .speaker-modal {
    flex-direction: column;
    align-items: center;
    text-align: center;
    &__avatar {
      width: 168px;
      height: 168px;
      margin: 28px;
    }
    &__info {
      margin-left: 0;
    }
  }
}
</style>
